import { formatCustomDate } from "helpers/dateTools";
import { dateValidator } from "helpers/dateValidator";
import {
  getRoutes,
  getSettlement,
  changeStationRoutes,
  fetchCausesAction
} from "redux/actions/routesStatus/routesStatusAction";
import { getUnitsConfigs } from "redux/actions/unitsSection/unitsAction";

export const handleSubmit = (dispatch, startDate, endDate, station, type, setSnackbar, resetTable) => {
  if (dateValidator(startDate, endDate, 7, setSnackbar)) return;
  if (station.length < 1) {
    setSnackbar("No se ha seleccionado alguna planta.");
    return;
  }
  if (type.length < 1) return setSnackbar("Tipo no seleccionado");
  const data = {
    start: formatCustomDate(startDate, '-'),
    end: formatCustomDate(endDate, '-'),
    station: station?.id,
    type
  };
  dispatch(getRoutes(data, getUnitsConfigs));
  resetTable('startEndRoutes');
};

export const submitSettlement = (
  dispatch,
  route,
  start,
  end,
  hist,
  stationary,
  idDispenser,
  manual) => {
  dispatch(fetchCausesAction());
  dispatch(getSettlement(route, start, end, hist, stationary, idDispenser, manual));
};

export const navToSettlement = (hist, route) => {
  const routeUrl = `/admin/rutas-liquidaciones/${route}`;
  hist.push(routeUrl);
};

export const handleSelectStation = (dispatch, station) => {
  dispatch(changeStationRoutes(station));
};
